var _rect, _circle, _rect2, _rect3, _rect4, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSelfPracticeBlueCircle = function SvgSelfPracticeBlueCircle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white",
    stroke: "#2037B5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.4918,
    cy: 17.8595,
    r: 3,
    fill: "#2037B5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.0978,
    y: 13.9533,
    width: 3,
    height: 3,
    rx: 1.5,
    transform: "rotate(111.025 29.0978 13.9533)",
    fill: "#2037B5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2316,
    y: 10.0763,
    width: 3,
    height: 3,
    rx: 1.5,
    transform: "rotate(111.025 21.2316 10.0763)",
    fill: "#2037B5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8766,
    y: 13.9533,
    width: 3,
    height: 3,
    rx: 1.5,
    transform: "rotate(111.025 13.8766 13.9533)",
    fill: "#2037B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5596 19.9811C27.8568 19.2078 27.4709 18.34 26.6976 18.0428C25.9244 17.7456 25.0565 18.1315 24.7593 18.9048L24.0448 20.7638L21.5881 22.1822C21.2313 22.0331 20.8405 21.9511 20.4323 21.9511H18.5513C18.0754 21.9511 17.6232 22.0625 17.2209 22.2618L14.1808 20.5828L13.3483 19.1407C12.934 18.4233 12.0167 18.1775 11.2992 18.5917C10.5818 19.0059 10.336 19.9233 10.7502 20.6407L11.7502 22.3728C11.8934 22.6209 12.0969 22.8127 12.3315 22.9402C12.4178 23.0195 12.5149 23.0899 12.6221 23.1491L15.5531 24.7678L14.8693 30.8593H24.1144L23.4136 24.6164C23.4127 24.6089 23.4118 24.6014 23.4109 24.5938L25.5526 23.3573C25.6589 23.296 25.7548 23.2236 25.8398 23.1424C26.2087 22.9912 26.5168 22.6941 26.6711 22.2926L27.5596 19.9811Z",
    fill: "#2037B5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSelfPracticeBlueCircle);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIzOSIgaGVpZ2h0PSIzOSIgcng9IjE5LjUiIGZpbGw9IndoaXRlIiBzdHJva2U9IiMyMDM3QjUiLz4KPGNpcmNsZSBjeD0iMTkuNDkxOCIgY3k9IjE3Ljg1OTUiIHI9IjMiIGZpbGw9IiMyMDM3QjUiLz4KPHJlY3QgeD0iMjkuMDk3OCIgeT0iMTMuOTUzMyIgd2lkdGg9IjMiIGhlaWdodD0iMyIgcng9IjEuNSIgdHJhbnNmb3JtPSJyb3RhdGUoMTExLjAyNSAyOS4wOTc4IDEzLjk1MzMpIiBmaWxsPSIjMjAzN0I1Ii8+CjxyZWN0IHg9IjIxLjIzMTYiIHk9IjEwLjA3NjMiIHdpZHRoPSIzIiBoZWlnaHQ9IjMiIHJ4PSIxLjUiIHRyYW5zZm9ybT0icm90YXRlKDExMS4wMjUgMjEuMjMxNiAxMC4wNzYzKSIgZmlsbD0iIzIwMzdCNSIvPgo8cmVjdCB4PSIxMy44NzY2IiB5PSIxMy45NTMzIiB3aWR0aD0iMyIgaGVpZ2h0PSIzIiByeD0iMS41IiB0cmFuc2Zvcm09InJvdGF0ZSgxMTEuMDI1IDEzLjg3NjYgMTMuOTUzMykiIGZpbGw9IiMyMDM3QjUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNy41NTk2IDE5Ljk4MTFDMjcuODU2OCAxOS4yMDc4IDI3LjQ3MDkgMTguMzQgMjYuNjk3NiAxOC4wNDI4QzI1LjkyNDQgMTcuNzQ1NiAyNS4wNTY1IDE4LjEzMTUgMjQuNzU5MyAxOC45MDQ4TDI0LjA0NDggMjAuNzYzOEwyMS41ODgxIDIyLjE4MjJDMjEuMjMxMyAyMi4wMzMxIDIwLjg0MDUgMjEuOTUxMSAyMC40MzIzIDIxLjk1MTFIMTguNTUxM0MxOC4wNzU0IDIxLjk1MTEgMTcuNjIzMiAyMi4wNjI1IDE3LjIyMDkgMjIuMjYxOEwxNC4xODA4IDIwLjU4MjhMMTMuMzQ4MyAxOS4xNDA3QzEyLjkzNCAxOC40MjMzIDEyLjAxNjcgMTguMTc3NSAxMS4yOTkyIDE4LjU5MTdDMTAuNTgxOCAxOS4wMDU5IDEwLjMzNiAxOS45MjMzIDEwLjc1MDIgMjAuNjQwN0wxMS43NTAyIDIyLjM3MjhDMTEuODkzNCAyMi42MjA5IDEyLjA5NjkgMjIuODEyNyAxMi4zMzE1IDIyLjk0MDJDMTIuNDE3OCAyMy4wMTk1IDEyLjUxNDkgMjMuMDg5OSAxMi42MjIxIDIzLjE0OTFMMTUuNTUzMSAyNC43Njc4TDE0Ljg2OTMgMzAuODU5M0gyNC4xMTQ0TDIzLjQxMzYgMjQuNjE2NEMyMy40MTI3IDI0LjYwODkgMjMuNDExOCAyNC42MDE0IDIzLjQxMDkgMjQuNTkzOEwyNS41NTI2IDIzLjM1NzNDMjUuNjU4OSAyMy4yOTYgMjUuNzU0OCAyMy4yMjM2IDI1LjgzOTggMjMuMTQyNEMyNi4yMDg3IDIyLjk5MTIgMjYuNTE2OCAyMi42OTQxIDI2LjY3MTEgMjIuMjkyNkwyNy41NTk2IDE5Ljk4MTFaIiBmaWxsPSIjMjAzN0I1Ii8+Cjwvc3ZnPgo=";